import type { CheckboxProps as MuiCheckboxProps } from '@mui/material';
import { Checkbox as MuiCheckbox } from '@mui/material';
import { useTracking } from '@packages/tracking';
import type {
  GTMEventGlycerinCheckboxClick,
  GlycerinCheckboxClickPayload,
} from '@packages/tracking';

import {
  Checkbox24,
  CheckboxDisabled24,
  CheckboxDisabledSelected24,
  CheckboxSelected24,
} from '@packages/themes/icons';

export type CheckboxProps = MuiCheckboxProps & {
  clickTrackingProps?: Omit<GlycerinCheckboxClickPayload, 'isChecked'>;
};

export const Checkbox: React.FC<CheckboxProps> = ({ clickTrackingProps, onClick, ...props }) => {
  const { disabled, checked } = props;
  const { category, label, detail, placement, variants, custom } = clickTrackingProps ?? {};
  const dispatchGTMEvent = useTracking();

  return (
    <MuiCheckbox
      icon={disabled ? <CheckboxDisabled24 /> : <Checkbox24 />}
      checkedIcon={disabled ? <CheckboxDisabledSelected24 /> : <CheckboxSelected24 />}
      disableFocusRipple
      onClick={(event) => {
        dispatchGTMEvent<GTMEventGlycerinCheckboxClick>({
          event: 'CheckboxClick',
          CheckboxClickData: {
            category: category ?? 'checkbox-click',
            label,
            detail,
            placement,
            isChecked: !checked ?? false,
            variants,
            custom,
          },
        });
        if (onClick) {
          onClick(event);
        }
      }}
      {...props}
      data-testid="mui-checkbox"
    />
  );
};
